import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Row, Col } from 'reactstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Table } from 'reactstrap';

import './PricingColumn.scss';

const limits = [
    ["", "Free", "Essential", "Professional", "Enterprise"],
    ["Connections", 1, 4, 10, "No Limit"],
    ["Query Editors", 1, 4, 10, "No Limit"],
    ["Apex Editors", 1, 4, 10, "No Limit"],
    ["Rest Explorers", 1, 4, 10, "No Limit"],
    ["Soql Grid Batches Fetched at a time", 1, 4, 10, "No Limit"],
    ["CSV Viewer Max Records", 2000, 50000, 100000, "No Limit"],
    ["Soql Grid Max Records", 2000, 50000, 100000, "No Limit"],
    ["Soql Grid Max Edits per Save", "NA", 200, 1000, "No Limit"],
    ["Execution History Items", "NA", 50, 500, "No Limit"],
    ["Saved Scripts Items", "NA", 50, 500, "No Limit"],
    ["Recent Files Items", "NA", 50, 500, "No Limit"],
    ["Favorite Items", "NA", 50, 500, "No Limit"],
    ["Dataloader Profiles", "NA", "NA", 10, "No Limit"],
    ["Dataloader Max Records per Run", "NA", "NA", 50000, 1000000],
    ["Fake Data Profiles", "NA", "NA", 10, "No Limit"],
    ["Fake Data Max Records per Generation", "NA", "NA", 10000, "No Limit"]
];

class PricingColumn extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            discountsModal: false,
            limitsModal: false
        };

        this.toggleDiscounts = this.toggleDiscounts.bind(this);
        this.toggleLimits = this.toggleLimits.bind(this);
    }

    toggleDiscounts() {
        this.setState({
            discountsModal: !this.state.discountsModal,
            limitsModal: false
        });
    }    

    toggleLimits() {
        this.setState({
            discountsModal: false,
            limitsModal: !this.state.limitsModal
        });
    }    

    render() {
        var props = this.props;
        return (
            <div className="pricing-column col-md-6 col-lg-3 py-2 mx-auto">

                <div className="card font-title text-center">
                    <div className="card-header bg-light">
                        <h3>{props.name}</h3>
                        {
                            props.cost
                            &&
                            <h4 className="cost p-2">${props.cost}</h4>
                        }
                        <span className="per-description">{props.per}</span>
                        <br />
                        {
                            props.cost
                            &&
                            <a className="multiseat-discount" href="javascript:void(0)" onClick={this.toggleDiscounts}>Multi Seat Discount</a>
                        }
                        <br/>
                        {
                            props.buyUrl &&
                            <Link className="btn-buy btn btn-outline-primary my-2 my-sm-0 btn-sm" to={props.buyUrl}>Buy Now</Link>
                        }
                        <br/>
                    </div>
                    <a className="view-limits" href="javascript:void(0)" onClick={this.toggleLimits}>View Limits</a>
                    <div className="pricing-entries card-body text-center">
                        <ul className="p-0">
                            {props.children}
                        </ul>
                    </div>
                    {
                        props.buyUrl &&
                        <div className="card-footer bg-light">
                            <Link className="btn-buy btn btn-outline-primary my-2 my-sm-0 btn-sm" to={props.buyUrl}>Buy Now</Link>
                        </div>
                    }
                </div>

                <Modal isOpen={this.state.discountsModal} fade={false} toggle={this.toggleDiscounts} className={this.props.className}>
                    <ModalHeader toggle={this.toggleDiscounts}>Realfire {props.name} - Discounts</ModalHeader>
                    <ModalBody>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>Seats</th>
                                    <th>Discount</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>0%</td>
                                    <td>${props.cost}</td>
                                </tr>
                                <tr>
                                    <td>2 - 4</td>
                                    <td>10%</td>
                                    <td>${Math.floor(props.cost * 0.9)}</td>
                                </tr>
                                <tr>
                                    <td>5 - 9</td>
                                    <td>15%</td>
                                    <td>${Math.floor(props.cost * 0.85)}</td>
                                </tr>
                                <tr>
                                    <td>10 - 19</td>
                                    <td>20%</td>
                                    <td>${Math.floor(props.cost * 0.8)}</td>
                                </tr>
                                <tr>
                                    <td>20+</td>
                                    <td>25%</td>
                                    <td>${Math.floor(props.cost * 0.75)}</td>
                                </tr>

                            </tbody>
                        </Table>

                    </ModalBody>
                    <ModalFooter>
                        <Button className="my-2 my-sm-0 btn-sm" onClick={this.toggleDiscounts}>Close</Button>
                    </ModalFooter>
                </Modal>
                
                <Modal isOpen={this.state.limitsModal} fade={false} toggle={this.toggleLimits} className="limits-modal" size="lg">
                    <ModalHeader toggle={this.toggleLimits}>Realfire - Limits</ModalHeader>
                    <ModalBody>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    {
                                        limits[0].map(header => <th>{header}</th>)
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    limits.slice(1).map(feature => <tr>{feature.map(item => <td>{item}</td>)}</tr>)
                                }
                            </tbody>
                        </Table>

                    </ModalBody>
                    <ModalFooter>
                        <Button className="my-2 my-sm-0 btn-sm" onClick={this.toggleLimits}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

PricingColumn.propTypes = {
    name: PropTypes.string,
    cost: PropTypes.number,
    per: PropTypes.string,
    buyUrl: PropTypes.string,
};

export default PricingColumn;


// WEBPACK FOOTER //
// ./src/components/pricingcolumn/PricingColumn.jsx